import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgManager = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M23.125 20.02a11.276 11.276 0 0 0-2.43-3.602 11.326 11.326 0 0 0-3.603-2.43c-.012-.007-.024-.01-.036-.016A7.476 7.476 0 0 0 12.678.434 7.476 7.476 0 0 0 5.2 7.913a7.471 7.471 0 0 0 3.1 6.063l-.036.015a11.227 11.227 0 0 0-3.603 2.43 11.326 11.326 0 0 0-2.43 3.604c-.561 1.32-.86 2.722-.89 4.163a.241.241 0 0 0 .241.248h1.81a.24.24 0 0 0 .24-.236 8.989 8.989 0 0 1 2.648-6.16 8.985 8.985 0 0 1 6.398-2.65c2.418 0 4.688.941 6.398 2.65a8.989 8.989 0 0 1 2.647 6.16.239.239 0 0 0 .241.236h1.81a.241.241 0 0 0 .24-.248 11.237 11.237 0 0 0-.889-4.166Zm-10.447-6.922a5.152 5.152 0 0 1-3.667-1.52 5.152 5.152 0 0 1-1.52-3.666c0-1.384.54-2.686 1.52-3.666a5.152 5.152 0 0 1 3.667-1.52c1.384 0 2.686.54 3.666 1.52s1.52 2.282 1.52 3.666-.54 2.686-1.52 3.666a5.152 5.152 0 0 1-3.666 1.52Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgManager)
const Memo = memo(ForwardRef)
export default Memo
